// extracted by mini-css-extract-plugin
export default {"years":"RcZud2","selected":"u1OP1C"};